var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPath({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 174,
    viewBox: "0 0 121 174",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#ECEEEF",
    fillRule: "nonzero",
    stroke: "#B2B2B2",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M911.077 430.727c2.144 1.242 3.145 3.797 2.415 6.162l-19.156 62.174h35.344c2.123 0 4.043 1.26 4.884 3.207.842 1.946.444 4.207-1.013 5.75l-85.087 90.307c-1.696 1.8-4.41 2.195-6.55.952-2.138-1.243-3.136-3.796-2.406-6.158l19.156-62.185H823.32c-2.123.001-4.043-1.26-4.884-3.206-.842-1.947-.444-4.207 1.013-5.75l85.087-90.307c1.693-1.798 4.404-2.194 6.541-.956v.01z",
    transform: "translate(-816 -428)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath);
export default __webpack_public_path__ + "static/media/path.01b8a212b271165fd573d5562be50dbc.svg";
export { ForwardRef as ReactComponent };